

































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import {CalendarEventAssistantStartEndPayload, CompanyFilterValue} from '@/types/payload'
import {
  GET_SELECTED_UI_LANGUAGE,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER,
  CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE, GET_SECURITY_LEVEL
} from '@/store/getter-types'
import {
  CALENDAR_EVENT_ASSISTANT_SET_START_END_DATA,
  LOAD_CALENDAR_EVENT_LIST
} from '@/store/action-types'
import { ActionsEnum } from '@/types/enums'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { CalendarEventSerie, GetCalendarEventTypesResponse, KalenderEventsCategorize } from '@/types/service-response'

interface ComponentData {
  dateStartIso: string
  dateEndIso: string
  hourStart: string
  hourEnd: string
  minuteStart: string
  minuteEnd: string
  hourRules: Array<Function>
  minuteRules: Array<Function>
  showErrorBadTime: boolean
  calendarEventList: KalenderEventsCategorize[]
  selectedCalendarEventId: number | undefined
}

export default Vue.extend({
  name: 'CalendarEventEditorStartEnd',

  props: {
    action: {
      type: String as () => ActionsEnum
    },
    editCalendarEvent: Object as () => CalendarEvent | undefined,
    editCalendarEventSerie: Object as () => CalendarEventSerie | undefined
  },

  computed: {
    dateEndFormatted (): string {
      return moment(this.dateEndIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStartFormatted (): string {
      return moment(this.dateStartIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStart (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]
    },

    companyFilter (): CompanyFilterValue {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER]
    },

    isDataValid (): boolean {
      const conditions = [
        ((): boolean => {
          const start = moment(`${this.dateStartIso} ${this.hourStart}:${this.minuteStart}`)
          const end = moment(`${this.dateEndIso} ${this.hourEnd}:${this.minuteEnd}`)

          return start.isBefore(end)
        })()
      ]

      return conditions.every(v => v)
    },

    isTemplateDisabled (): boolean {
      if(this.editCalendarEvent && this.editCalendarEvent.id) {
        return true
      } else {
        return false
      }
    },

    isDateDisabled (): boolean {
      return (this.action === ActionsEnum.EDIT)
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    securityLevel (): number | undefined {
      return this.$store.getters[GET_SECURITY_LEVEL]
    }
  },

  data (): ComponentData {

    const todayIso = moment().format('YYYY-MM-DD')

    return {
      dateStartIso: todayIso,
      dateEndIso: todayIso,
      hourStart: '00',
      hourEnd: '00',
      minuteStart: '00',
      minuteEnd: '00',

      hourRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 24) || this.$t('planningPage.badValue')
        }
      ],

      minuteRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 60) || this.$t('planningPage.badValue')
        }
      ],

      showErrorBadTime: false,
      calendarEventList: [],
      selectedCalendarEventId: undefined,
    }
  },

  watch: {
    isDataValid (newVal: boolean): void {
      this.showErrorBadTime = !newVal
    },
  },

  methods: {
    onFieldStartChange (): void {
      this.dateEndIso = this.dateStartIso
      this.onFieldValueChange()
    },

    onFieldEndChange (): void {
      this.onFieldValueChange()
    },

    onFieldValueChange (): void {
      if (this.isDataValid) {
        this.showErrorBadTime = false
        this.updateStoreValues()
      } else {
        this.showErrorBadTime = true
      }
    },

    onCalendarEventChange (): void {
      this.hourStart = this.formatHour(new Date('2021-01-21T00:00:00'))
      this.minuteStart = this.formatMinute(new Date('2021-01-21T00:00:00'))

      this.hourEnd = this.formatHour(new Date('2021-01-21T23:59:59'))
      this.minuteEnd = this.formatMinute(new Date('2021-01-21T23:59:59'))

      this.updateStoreValues()
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    formatHour (date: Date): string {
      return moment(date).format('HH')
    },

    formatMinute (date: Date): string {
      return moment(date).format('mm')
    },

    normalizeDateStart (): Date {
      const dateStart = this.dateStartIso
      const hourStart = this.hourStart
      const minuteStart = this.minuteStart

      const dateStr = `${dateStart} ${hourStart.padStart(2, '0')}:${minuteStart.padStart(2, '0')}`

      return moment(dateStr).toDate()
    },

    normalizeDateEnd (): Date {
      const dateEnd = this.dateEndIso
      const hourEnd = this.hourEnd
      const minuteEnd = this.minuteEnd

      const dateStr = `${dateEnd} ${hourEnd.padEnd(2, '0')}:${minuteEnd.padEnd(2, '0')}`

      return moment(dateStr).toDate()
    },

    updateStoreValues () {
      const reasonItem: KalenderEventsCategorize | undefined = _.find(this.calendarEventList, { id: this.selectedCalendarEventId }) as KalenderEventsCategorize

      const payload: CalendarEventAssistantStartEndPayload = {
        dateStart: this.normalizeDateStart(),
        dateEnd: this.normalizeDateEnd(),
        calendarEventItem: reasonItem
      }

      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_START_END_DATA, payload)
    },
  },

  async mounted () {

    this.dateStartIso = this.formatDateIso(this.dateStart)
    this.hourStart = this.formatHour(this.dateStart)
    this.minuteStart = this.formatMinute(this.dateStart)

    this.dateEndIso = this.formatDateIso(this.dateEnd)
    this.hourEnd = this.formatHour(this.dateEnd)
    this.minuteEnd = this.formatMinute(this.dateEnd)

    if (this.companyFilter.profitCenter) {
      try {
        const response: GetCalendarEventTypesResponse = await this.$store.dispatch(LOAD_CALENDAR_EVENT_LIST, this.companyFilter.profitCenter.id)

        if (response && !response.IsError) {
          if(this.securityLevel === 7) {
            this.calendarEventList = response.Data.filter((item: KalenderEventsCategorize) => item.id === 2)
          } else {
            this.calendarEventList = response.Data
          }
          this.calendarEventList = _.sortBy(this.calendarEventList, [function(o) { return o.text ? o.text.toLocaleLowerCase() : false }])
          if(this.calendarEventList[0] && this.calendarEventList[0].id) {
            this.selectedCalendarEventId = this.calendarEventList[0].id
          }
          if (this.action !== ActionsEnum.EDIT) {
            this.onCalendarEventChange()
          }
        } else {

        }
      } catch {

      }
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)

    /*if (this.editCalendarEvent) {
      this.selectedCalendarEventId = this.editCalendarEvent.id
      this.updateStoreValues()
    } else if(this.editCalendarEventSerie) {
      this.selectedCalendarEventId = this.editCalendarEventSerie.id
      this.updateStoreValues()
    }*/
  }
})
